import type { EventPayload } from '@side/analytics';

export enum TrackContactModalEvent {
  Mount,
  FieldUpdate,
  ClickBackToEditingButton,
  Close,
  ClickSaveButton,
  ClickUseExistingContactButton,
  ClickUpdateButton,
  ClickExistingContactBannerButton,
}

type EventTypeLabels = Record<TrackContactModalEvent, string>;

export const ContactModalEventLabels: EventTypeLabels = {
  [TrackContactModalEvent.Mount]: 'CONTACT_MODAL',
  [TrackContactModalEvent.FieldUpdate]: 'CONTACT_MODAL',
  [TrackContactModalEvent.ClickBackToEditingButton]: 'CONTACT_MODAL',
  [TrackContactModalEvent.Close]: 'CONTACT_MODAL',
  [TrackContactModalEvent.ClickSaveButton]: 'CONTACT_MODAL',
  [TrackContactModalEvent.ClickUseExistingContactButton]: 'CONTACT_MODAL',
  [TrackContactModalEvent.ClickUpdateButton]: 'CONTACT_MODAL',
  [TrackContactModalEvent.ClickExistingContactBannerButton]: 'CONTACT_MODAL',
};

type EventTypePayloads = Record<TrackContactModalEvent, EventPayload>;

export const ContactModalEventMap: EventTypePayloads = {
  [TrackContactModalEvent.Mount]: {
    eventContainer: '',
    eventTarget: 'manual_contact_modal',
    eventType: 'load',
    task: 'view',
  },
  [TrackContactModalEvent.FieldUpdate]: {
    eventContainer: 'manual_contact_modal',
    eventTarget: '',
    eventType: 'blur',
    task: 'modify_input',
  },
  [TrackContactModalEvent.ClickBackToEditingButton]: {
    eventContainer: 'manual_contact_modal',
    eventTarget: 'back_to_editing_button',
    eventType: 'click',
    task: 'navigate',
  },
  [TrackContactModalEvent.Close]: {
    eventContainer: '',
    eventTarget: '',
    eventType: 'click',
    task: 'exit',
  },
  [TrackContactModalEvent.ClickSaveButton]: {
    eventContainer: 'manual_contact_modal',
    eventTarget: 'save_contact_button',
    eventType: 'click',
    task: 'add',
  },
  [TrackContactModalEvent.ClickUseExistingContactButton]: {
    eventContainer: 'manual_contact_modal_existing',
    eventTarget: 'existing_contact_button',
    eventType: 'click',
    task: 'select',
  },
  [TrackContactModalEvent.ClickUpdateButton]: {
    eventContainer: 'manual_contact_modal',
    eventTarget: 'save_contact_button',
    eventType: 'click',
    task: 'update',
  },
  [TrackContactModalEvent.ClickExistingContactBannerButton]: {
    eventContainer: 'existing_contact_banner',
    eventTarget: 'existing_contact_banner',
    eventType: 'click',
    task: 'select',
  },
};
